import Handlebars from 'handlebars';
import AMApp from '../../global/app';

/**
 * AvailableFonds Module (Plain JS)
 */
export default class AvailableFonds {
  constructor(element, options = {}) {
    this.element = element;
    this.amApp = new AMApp();

    this.settings = {
      routeAllFonds: AMApp.langGetParam + 'eID=fonds&function=allFonds',
      routeQuickSearch: AMApp.langGetParam + 'eID=fonds&function=instant&search=',
      ...options
    };

    this.fondsSearchInputSelector = '#availablefonds_input';
    this.searchInput = this.element.querySelector(this.fondsSearchInputSelector);

    this.fondsSearchResult = document.getElementById('fonds_search_result');
    this.fondsSearchResultTarget = document.getElementById('fonds_search_result_target');
    this.fondsSearchButton = document.getElementById('fonds_search_button');

    this.timeoutId = null;
    this.hasResult = false;

    this.init();
  }

  init() {
    console.log('### AvailableFonds ###', this.searchInput);
    if (!this.searchInput) return;

    // Events
    this.searchInput.addEventListener('keyup', (event) => {
      clearTimeout(this.timeoutId);
      const value = event.target.value;

      if (value.length > 0) {
        this.timeoutId = setTimeout(() => {
          this.getFondsSearchResult(value);
        }, 500);
      }
    });

    this.searchInput.addEventListener('click', () => this.handleFocus());
    this.searchInput.addEventListener('focus', () => this.handleFocus());

    // Event Delegation für dynamische Elemente (data-andiid)
    this.element.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-andiid]');
      if (trigger) {
        event.preventDefault();
        this.searchInput.value = trigger.dataset.name;
      }
    });

    // Klick außerhalb schließt die Ergebnisse
    document.addEventListener('click', (event) => {
      if (!event.target.closest(this.fondsSearchInputSelector)) {
        this.fondsSearchResult?.classList.remove('hasresult');
      }
    });
  }

  handleFocus() {
    if (this.hasResult) {
      this.fondsSearchResult?.classList.add('hasresult');
    }
  }

  async getFondsSearchResult(searchInput) {
    console.log('### getFondsSearchResult ###');
    if (this.fondsSearchButton) this.fondsSearchButton.style.display = 'none';

    if (!this.searchInput.nextElementSibling?.classList.contains('loader')) {
      this.searchInput.insertAdjacentHTML('afterend', AMApp.LOADING_ANIMATION);
    }

    const url = AMApp.basePath + this.settings.routeQuickSearch + encodeURIComponent(searchInput)
      + '&target=' + this.getTarget();

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const result = await response.json();
      this.success(result);
    } catch (error) {
      this.fail();
    }
  }

  getTarget() {
    if (document.getElementById('dividend') || document.getElementById('historicalfondsprices')) {
      return 'A';
    }
    return window.location.pathname.startsWith('/institutionell/') ? 'I' : 'R';
  }

  success(result) {
    if (result) {
      if (result.length > 0) {
        setTimeout(() => {
          this.renderFondsSearchResult(result);
        }, 250);
      } else {
        this.showFondsSearchNoResultMessage();
      }
    }
  }

  fail() {
    this.showFondsSearchFailMessage();
    this.removeLoader();
  }

  renderFondsSearchResult(result) {
    const processedResult = result.map(fonds => {
      const temp = document.createElement('div');
      temp.innerHTML = fonds['INSD_NAME'] || '';
      fonds['INSD_NAME'] = temp.textContent;
      temp.innerHTML = fonds['INSD_ISIN'] || '';
      fonds['INSD_ISIN'] = temp.textContent;
      return fonds;
    });

    let htmlOutput = '';
    const templateElement = document.getElementById('fonds_search_result_template');

    if (templateElement) {
      const rawTemplate = templateElement.innerHTML;
      const compiledTemplate = Handlebars.compile(this.amApp.toHandlebarsDelimiters(rawTemplate));
      htmlOutput = compiledTemplate({ data: processedResult });
    }

    if (processedResult.length === 1 && processedResult[0].message) {
      htmlOutput = `<li class="no-result">${processedResult[0].message}</li>`;
    }

    if (this.fondsSearchResultTarget) {
      this.fondsSearchResultTarget.innerHTML = htmlOutput;
    }

    if (this.fondsSearchButton) this.fondsSearchButton.style.display = '';
    this.fondsSearchResult?.classList.add('hasresult');
    this.hasResult = true;
    this.removeLoader();
  }

  showFondsSearchNoResultMessage() {
    const message = [{ message: AMApp.translations.response.noResult }];
    this.renderFondsSearchResult(message);
  }

  showFondsSearchFailMessage() {
    const message = [{ message: AMApp.translations.response.fail }];
    this.renderFondsSearchResult(message);
  }

  removeLoader() {
    const loaders = this.element.querySelectorAll('.loader');
    loaders.forEach(loader => loader.remove());
  }
}